import { inject } from 'vue';
import { CONFETTI_CONTROLLER_KEY, type ConfettiController } from '@/components/confetti/use-confetti-provider.ts';

export function useConfetti() {
    const controller = inject<ConfettiController>(CONFETTI_CONTROLLER_KEY);
    if (!controller) {
        throw new Error('useConfetti must be used within a ConfettiProvider');
    }
    return controller;
}
